import React, { Component } from 'react';
// import { PasswordInput, Create, SimpleForm, required } from 'react-admin';


// class ChangePasswordForm extends Component {

//     constructor(props) {
//         super(props);
//         let _cha = localStorage.getItem("cha");
//         let _ses = localStorage.getItem("sess");
//         let _ubs = localStorage.getItem("ubs");
//         let asd = localStorage.getItem("asda");
//         this.state = {
//             cha: _cha,
//             ses: _ses,
//             ubs: _ubs,
//             asd: asd
//         }
//         this.backToLogin = this.backToLogin.bind(this);
//     }

//         localStorage.removeItem("ubs");
//         localStorage.removeItem("asda");
//         window.location.replace(baseUrl + "/#/login");
//         return;
//     }

//     render() {
//         let props = this.props;
//         const { cha, ses, ubs, asd } = this.state;
//         return (
//             <div>
//             <Create {...props}>
//                 <SimpleForm defaultValue={{ "cha": cha, "ses": ses, "username": ubs }} submitOnEnter={false}>
//                     <PasswordInput validate={[required()]} source="pato" label='Contraseña actual'/>
//                     <PasswordInput validate={[required()]} source="kiosco" label='Nueva contraseña'/>
//                     <PasswordInput validate={[required()]} source="hola" label='Repetir contraseña'/>
//                 </SimpleForm>
//             </Create>
//                 <br />
//                 <br />
//                 <br />
//                 <form method="get" action="/#/login">
//                     <button type="submit">Volver al login</button>
//                 </form>

//             </div>
//         )
//     }
// };

// ChangePasswordForm.propTypes = {
// };

// export default ChangePasswordForm;

import { Create, SimpleForm, PasswordInput, required, useNotify, useRefresh, useRedirect, regex } from 'react-admin';
import Button from '@material-ui/core/Button';

// eslint-disable-next-line
const passwordInput = regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!.\-,%_+\(\)¡*#¿=?&])[A-Za-z\d@_.\-$!#,+=\(\)%¡¿*?&]{8,}$/, 'Debe contener mayúsculas, minúsculas, 8 caracteres mínimo, símbolos @$!.\-,%_+()¡*#¿=?& y números.');

class ChangePasswordForm extends Component {
    
    constructor(props) {
        super(props);
        console.log("asdsad");
        this.state = {
            notify: useNotify,
            redirect: useRedirect,
            refresh: useRefresh,
            cha: null,
            ses: null,
            ubs: null
        }
        
        this.backButton = this.backButton.bind(this);
    }
    
    componentDidMount() {
        let _cha, _ses, _ubs;
        try {
            _cha = localStorage.getItem("cha");
            _ses = localStorage.getItem("sess");
            _ubs = localStorage.getItem("ubs");
            console.log("kasdsad", _cha, _ses, _ubs);
        } catch (e) {
            console.log(e);
        }
        if (_cha === null || _cha === undefined) {
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host
            window.location = baseUrl + "/#/login";
        }
        this.setState({
            cha: _cha,
            ses:  _ses,
            ubs: _ubs
        })
    }
    backButton() {
        localStorage.removeItem('cha');
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host
        window.location = baseUrl + "/#/login";
    }

    render() {
        console.log(this.state);
        return (
            <div>
               <Button color="primary" onClick={() => this.backButton()}>
                    Volver al inicio
               </Button>
        <Create {...this.props}>
            <SimpleForm defaultValue={{"cha": this.state.cha, "ses": this.state.ses, "username": this.state.ubs}} onSuccess={() => {
                const red = useRedirect();
                red('/#/login');
            }} submitOnEnter={false}>
                <PasswordInput validate={[required()]} source="pato" label='Contraseña actual'/>
                <PasswordInput validate={[required(), passwordInput]} source="kiosco" label='Contraseña'/>
                <PasswordInput validate={[required(), passwordInput]} source="hola" label='Repetir contraseña'/>
            </SimpleForm>
        </Create>
            </div>
        )
    }
};

ChangePasswordForm.propTypes = {
};

export default ChangePasswordForm;